
import StringUtils from "../../../../utils/StringUtils.js";
import { SubDomain } from "../../SubDomain.js";
import AiOperations from "../AiOperations.js";
import AiPrompt from "./AiPrompt.js";

export default class AiPromptDomain extends SubDomain {

  constructor(domain, storage) {
    super(domain, AiPrompt.MODEL_NAME);
    this._storage = storage.AiPromptStorage;
  }

  list() {
    return this._storage.list;
  }

  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        return new AiPrompt(this.domain, item);
      }
    }

    let newItem = new AiPrompt(this.domain);
    if (StringUtils.isNotEmpty(objId)) {
      newItem.withId(objId);
    }
    return newItem;
  }

  operations() {
    return new AiOperations(this.domain.events());
  }
}